import Area from '@/components/Area';
import { MantineProvider, Slider } from '@mantine/core';
import { Html, OrbitControls } from '@react-three/drei';
import { Canvas, useThree } from '@react-three/fiber';
import * as React from 'react';

function Box() {
  const [size, setSize] = React.useState(0.5);
  const events = useThree((state) => state.events)!;
  return (
    <mesh scale={size * 2}>
      <boxGeometry />
      <meshStandardMaterial color="orange" />
      <Html>
        <MantineProvider>
          <div css={{ border: '1px solid black', padding: '10px', display: 'flex', alignItems: 'center' }}>
            <span css={{ pointerEvents: 'none', userSelect: 'none' }}>Size</span>
            <Slider
              css={{ width: '100px' }}
              value={size}
              min={0.5}
              max={1}
              step={0.1}
              onChange={(valueNext) => {
                setSize(valueNext);
              }}
              onMouseDown={() => {
                events.enabled = false;
              }}
              onMouseUp={() => {
                events.enabled = true;
              }}
            />
          </div>
        </MantineProvider>
      </Html>
    </mesh>
  );
}

export type Props = {};

function App01(props: Props) {
  const {} = props;

  return (
    <Area>
      {() => (
        <>
          <Canvas shadows camera={{ position: [1, 1.5, 2.5], fov: 50 }}>
            <ambientLight intensity={0.5} />
            <directionalLight
              position={[-5, 5, 5]}
              castShadow
              shadow-mapSize-width={1024}
              shadow-mapSize-height={1024}
            />
            <Box />
            {/* <Model pose={0} /> */}
            <OrbitControls />
            <gridHelper />
          </Canvas>
        </>
      )}
    </Area>
  );
}

export default React.memo(App01);
